export default __webpack_public_path__ + "static/media/carosello7.7dca2054.png";